import React, { useContext, useEffect, useState } from 'react';
import '../TabNotificationRow.scss';
import './TabNotificationRowModeration.scss';
import { Button, Modal } from 'antd';
import { Appeal } from '../../../model/Appeal';
import AppealDescription from '../../Appeal/AppealDescription/AppealDescription';
import { RejectionReason } from '../../../model/RejectionReason';
import { Context } from '../../../index';

interface TabNotificationRowModerationProps {
  appeal: Appeal;
  handleAppealRemove: (appealId: number) => void;
}

const TabNotificationRowModeration = (
  props: TabNotificationRowModerationProps
): JSX.Element => {
  const [comment, setComment] = useState('');
  const [rejectionReasons, setRejectionReasons] = useState<RejectionReason[]>(
    []
  );
  const [reason, setReason] = useState<number>(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { store } = useContext(Context);

  useEffect(() => {
    store.getRejectionReasons().then((resp) => {
      if (resp) {
        setRejectionReasons(resp);
      }
    });
  }, []);

  const handleModeration = (status: boolean, rejectionReason?: number) => {
    const moderationStatus = {
      id: props.appeal.id,
      comment: comment,
      rejectionReason: rejectionReason ? rejectionReason : null,
      status: status,
    };

    store.setAppealModerationStatus(moderationStatus).then((res) => {
      if (res) {
        props.handleAppealRemove(moderationStatus.id);
      }
    });
  };

  return (
    <div className="TabNotificationRowModeration">
      <div>
        <AppealDescription
          data={comment}
          setDescription={setComment}
          label={'Комментарий'}
        />
      </div>
      <Button.Group>
        <Button type="primary" onClick={() => handleModeration(true)}>
          Принять
        </Button>
        <Button type="primary" danger onClick={() => setIsModalVisible(true)}>
          Отклонить
        </Button>
      </Button.Group>
      <Modal
        className="rejectContainer"
        title="Причина отклонения"
        visible={isModalVisible}
        wrapClassName="rejectionModal"
        onCancel={() => {
          setIsModalVisible(false);
        }}
        footer={[
          <Button
            className="rejectButton"
            key="submit"
            type="primary"
            onClick={() => {
              handleModeration(false, reason);
              setIsModalVisible(false);
            }}
          >
            Подтвердить отклонение
          </Button>,
        ]}
      >
        <div>
          {rejectionReasons.map((item: RejectionReason) => {
            return (
              <div
                className={`rejectReasonOption ${
                  reason === item.id ? 'active' : ''
                }`}
                key={item.id}
                onClick={() => setReason(item.id)}
              >
                {item.text}
              </div>
            );
          })}
        </div>
      </Modal>
    </div>
  );
};

export default TabNotificationRowModeration;
